import React from 'react';
import { TariffConfigurationContextProvider } from '../../context/tariff-configuration-context';
import TariffConfigurationForm from './tariff-configuration-form';

const TariffConfiguration: React.FC = () => (
  <TariffConfigurationContextProvider>
    <TariffConfigurationForm />
  </TariffConfigurationContextProvider>
);

export default TariffConfiguration;
